export default import.meta.ROLLUP_FILE_URL_CI5Wb6ys;